import toastService from "services/toastService";

/**
 * Toast helpers for agent scoring rule CRUD / load / access operations.
 * Operation keys resolve against `agentScoringRules.notifications.*`;
 * shared title / access copy lives under `agentScoringRules.common.*`.
 */

const PREFIX = "agentScoringRules.notifications";
const COMMON = "agentScoringRules.common.labels";

function notifySuccess(operation: "create" | "update" | "delete"): void {
    toastService.notifyMessage(
        `${PREFIX}.${operation}.title`,
        {
            bodyMessageKey: `${PREFIX}.${operation}.successMessage`,
            icon: "fa-check-circle",
        },
        false
    );
}

function notifyFailure(
    operation: "create" | "update" | "delete" | "load" | "listLoad"
): void {
    const titleKey =
        operation === "listLoad"
            ? `${COMMON}.title`
            : `${PREFIX}.${operation}.title`;
    toastService.notifyMinorAlert(titleKey, {
        bodyMessageKey: `${PREFIX}.${operation}.failureMessage`,
    });
}

export const agentScoringRulesToasts = {
    createSuccess: () => notifySuccess("create"),
    createFailure: () => notifyFailure("create"),
    updateSuccess: () => notifySuccess("update"),
    updateFailure: () => notifyFailure("update"),
    deleteSuccess: () => notifySuccess("delete"),
    deleteFailure: () => notifyFailure("delete"),
    loadFailure: () => notifyFailure("load"),
    listLoadFailure: () => notifyFailure("listLoad"),
    accessDenied: () =>
        toastService.notifyMinorAlert(`${COMMON}.title`, {
            bodyMessageKey: `${COMMON}.accessRestricted`,
        }),
};

export default agentScoringRulesToasts;
